module.exports = __webpack_public_path__ + "static/media/image (28).c77ab9ee.jpg";